import { Page } from '@/components/layout/Page';
import { PageContent } from '@/components/layout/PageContent';
import { Skeleton } from '@/components/ui/Skeleton';

function StatCardSkeleton() {
    return (
        <div className="bg-white/15 backdrop-blur-sm rounded-2xl p-3 md:p-4 space-y-2">
            <Skeleton className="h-3 w-20 bg-white/20" />
            <Skeleton className="h-7 w-12 bg-white/20" />
        </div>
    );
}

function RaceCardSkeleton() {
    return (
        <div className="bg-white p-5 rounded-2xl border border-slate-100 shadow-sm space-y-3">
            <div className="flex justify-between items-start">
                <Skeleton className="h-5 w-3/4" />
                <Skeleton className="w-16 h-5 rounded-full" />
            </div>
            <div className="space-y-2">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-4 w-24" />
            </div>
        </div>
    );
}

function BetCardSkeleton() {
    return (
        <div className="bg-white p-4 rounded-2xl border border-slate-100 shadow-sm min-w-[240px] md:min-w-0 space-y-2">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-3 w-16 rounded-full" />
            <Skeleton className="h-3 w-24" />
        </div>
    );
}

function LeaderboardEntrySkeleton() {
    return (
        <div className="px-4 py-3 flex items-center gap-3">
            <Skeleton className="w-7 h-7 rounded-full" />
            <Skeleton className="w-8 h-8 rounded-full" />
            <div className="flex-1 space-y-1">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-3 w-16" />
            </div>
            <Skeleton className="h-4 w-16" />
        </div>
    );
}

function QuickActionSkeleton() {
    return (
        <div className="bg-white p-4 rounded-2xl border border-slate-100 shadow-sm flex flex-col items-center gap-2">
            <Skeleton className="w-10 h-10 rounded-full" />
            <Skeleton className="h-4 w-20" />
        </div>
    );
}

export function HomePageSkeleton() {
    return (
        <Page className="bg-slate-50">
            <PageContent width="wide" className="space-y-6 md:space-y-8 pb-24">
                {/* Hero skeleton */}
                <div className="bg-gradient-to-br from-emerald-600 to-emerald-700 rounded-3xl p-6 md:p-8 relative overflow-hidden">
                    <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/3" />
                    <div className="relative space-y-4">
                        <Skeleton className="h-8 w-56 bg-white/20" />
                        <Skeleton className="h-4 w-72 bg-white/15" />
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mt-2">
                            <StatCardSkeleton />
                            <StatCardSkeleton />
                            <StatCardSkeleton />
                            <StatCardSkeleton />
                        </div>
                    </div>
                </div>

                {/* 2-column layout */}
                <div className="flex flex-col lg:flex-row lg:gap-8">
                    {/* Main column */}
                    <div className="flex-1 min-w-0 space-y-6 md:space-y-8">
                        {/* Open Races */}
                        <div className="space-y-4">
                            <Skeleton className="h-5 w-40" />
                            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-2">
                                {Array.from({ length: 4 }).map((_, i) => (
                                    <RaceCardSkeleton key={i} />
                                ))}
                            </div>
                        </div>

                        {/* My Bets */}
                        <div className="space-y-4">
                            <Skeleton className="h-5 w-32" />
                            <div className="flex gap-4 overflow-hidden md:grid md:grid-cols-2 lg:grid-cols-2">
                                {Array.from({ length: 3 }).map((_, i) => (
                                    <BetCardSkeleton key={i} />
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Sidebar */}
                    <div className="lg:w-80 xl:w-96 space-y-6 md:space-y-8 mt-6 md:mt-8 lg:mt-0 flex-shrink-0">
                        {/* Leaderboard */}
                        <div className="space-y-4">
                            <Skeleton className="h-5 w-36" />
                            <div className="bg-white rounded-2xl border border-slate-100 shadow-sm divide-y divide-slate-100">
                                <LeaderboardEntrySkeleton />
                                <LeaderboardEntrySkeleton />
                                <LeaderboardEntrySkeleton />
                            </div>
                        </div>

                        {/* Quick Actions */}
                        <div className="space-y-4">
                            <Skeleton className="h-5 w-32" />
                            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-2 gap-3">
                                <QuickActionSkeleton />
                                <QuickActionSkeleton />
                                <QuickActionSkeleton />
                            </div>
                        </div>
                    </div>
                </div>
            </PageContent>
        </Page>
    );
}
